module.exports = __webpack_public_path__ + "static/media/Manual_do_portal_do_TCC_Funcionario.4368b153.pdf";